module.exports = __webpack_public_path__ + "static/media/add-cut-off-time.cdeea1a4.svg";